export default "/assets/images/column-image7.9556f83a4c7304c6.png";